import {
  Component,
  ViewChild,
  OnInit,
  AfterViewInit,
  OnDestroy,
  Input,
  ElementRef,
} from '@angular/core';
import { Chart } from 'chart.js';
import { ReplaySubject, Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';

@Component({
  selector: 'app-line-chart',
  templateUrl: './line-chart.component.html',
  styleUrls: ['./line-chart.component.scss'],
})
export class LineChartComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('chartEl') chartEl: ElementRef<HTMLCanvasElement>;

  data$ = new ReplaySubject<{ data: Chart.ChartPoint[]; labels: string[] }>();
  @Input() set data(data: { data: Chart.ChartPoint[]; labels: string[] }) {
    this.data$.next(data);
  }

  @Input() type = 'line';
  @Input() lineColor = '#1B7A91';
  @Input() backgroundColor = '';
  @Input() label = '';
  @Input() isLoading: boolean;

  chart: Chart;

  onDestroy$ = new Subject();

  constructor() {
    this.data$
      .pipe(
        takeUntil(this.onDestroy$),
        tap((chartData) => {
          if (this.chart && chartData) {
            const { data, labels } = chartData;
            this.chart.data.labels = labels;
            this.chart.data.datasets = [
              {
                borderColor: this.lineColor,
                type: this.type,
                label: this.label,
                backgroundColor: this.backgroundColor,
                data,
              },
            ];
            this.chart.update();
          }
        }),
      )
      .subscribe();
  }

  ngOnInit() {}

  initChart() {
    this.chart = new Chart(this.chartEl.nativeElement, {
      type: this.type,
      data: {
        labels: [],
        datasets: [],
      },
    });
  }

  ngAfterViewInit() {
    this.initChart();
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.unsubscribe();
  }
}
